(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-absorbency-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-absorbency-bar')) {
    class VariantAbsorbencyBar extends HTMLElement {
      connectedCallback() {
        this.valuesElement = this.querySelector('[data-absorbency-values]');
        this.bar = this.querySelector('.absorbency-bar');
        this.track = this.querySelector('.absorbency-bar__track');
        this.fill = this.querySelector('.absorbency-bar__fill');
        this.interval = this.querySelector('.absorbency-bar__interval');

        try {
          this.values = JSON.parse(this.valuesElement.textContent);
        } catch (error) {
          this.values = {};
        }

        this.onVariantChange = this.handleVariantChange.bind(this);
        document.addEventListener('variant:change', this.onVariantChange);
        this.update(this.dataset.currentVariantId);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:change', this.onVariantChange);
      }

      handleVariantChange(event) {
        this.update(event.detail?.variant?.id);
      }

      hideBar() {
        this.bar.hidden = true;
        this.track.removeAttribute('aria-valuenow');
        this.track.removeAttribute('aria-valuetext');
        this.interval.textContent = '';
        this.interval.hidden = true;
      }

      update(variantId) {
        if (variantId == null) {
          this.hideBar();
          return;
        }

        const data = this.values[String(variantId)];

        if (!data || data.percentage == null || String(data.percentage).trim() === '') {
          this.hideBar();
          return;
        }

        const percentage = Number(data.percentage);

        if (!Number.isFinite(percentage)) {
          this.hideBar();
          return;
        }

        const normalizedPercentage = Math.min(100, Math.max(0, percentage));
        const interval = data.interval == null ? '' : String(data.interval);

        this.bar.hidden = false;
        this.fill.style.setProperty('--absorbency-level', `${normalizedPercentage}%`);
        this.track.setAttribute('aria-valuenow', String(normalizedPercentage));

        if (interval) {
          this.track.setAttribute('aria-valuetext', interval);
          this.interval.textContent = interval;
          this.interval.hidden = false;
        } else {
          this.track.removeAttribute('aria-valuetext');
          this.interval.textContent = '';
          this.interval.hidden = true;
        }
      }
    }

    customElements.define('variant-absorbency-bar', VariantAbsorbencyBar);
  }
  } catch(e) { console.error(e); }
})();

})();
